

















































































































import { Component, Prop, Emit, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import SolicitacaoStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoStore'
import BackofficeFidelizacaoStore from '@/components/Backoffice/Store/BackofficeFidelizacaoStore'
import EventBus from '@/plugins/EventBus'
import { IProtocolo, IProtocoloFornecedor } from '@/types/interfaces/protocolo/protocolo.interface'
import SolicitacaoCirurgiaApi from '@/Apis/Agendamento/Services/SolicitacaoCirurgiaApi'
import { ProtocoloJustificativaOrigemEnum } from '@/types/interfaces/protocolo/protocolo-justificativa-do-medico.interface'
import SolicitacaoCirurgiaStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoCirurgiaStore'
import ReservaDeSangueStore from './store/ReservaDeSangueStore'
import ComponentProtocoloComparativo from '../Backoffice/sessao/ProtocoloComparativo.vue'

@Component
export default class ComponentModalSolicitacaoCirurgiaPendenciaProtocolo extends Vue {
  $refs: {
    protocoloComparativo: ComponentProtocoloComparativo
  }

  @Prop({ required: false }) doctorReasonProtocolRejection = ''

  @Emit('refreshDoctorSurgerySolicitations')
  refreshDoctorSurgerySolicitations() {}

  @Emit('closeManagementSurgeryModal')
  closeManagementSurgeryModal() {}

  loadingSaveProtocol: boolean = false
  showConfirmationModal: boolean = false
  loadingConfirmProtocolSuggestion: boolean = false

  showRejectProtocolModal: boolean = false
  reasonProtocolRejection: string = ''
  surgeryTechnique = ''
  selectedKitId: string = ''
  protocol = ''
  materialData: any = {
    opmes: [],
  }

  doctorSurgeryTechnique = ''
  doctorSelectedKitId: string = ''
  doctorProtocol = ''
  selectedProtocolData: any = {}

  availableSurgeryOpmeKits: any[] = []
  availableSurgeryTechniques: any[] = []
  protocolData: any = {}

  getOpmeSupplierLabel(suppliers) {
    if (suppliers && suppliers.length > 0) {
      const firstSupplierName = suppliers[0].description
      const totalSuppliers = suppliers.length

      if (suppliers.length === 1) {
        return firstSupplierName
      }

      const extraSuppliersCount = totalSuppliers - 1
      return `${firstSupplierName} +${extraSuppliersCount} ${extraSuppliersCount === 1 ? 'fornecedor' : 'fornecedores'}`
    }

    return '-'
  }

  getOpmeSupplierLabelV2(data: IProtocoloFornecedor[]) {
    if (data && data.length > 0) {
      const firstSupplierName = data[0].fornecedorNome
      const totalSuppliers = data.length

      if (data.length === 1) {
        return firstSupplierName
      }

      const extraSuppliersCount = totalSuppliers - 1
      return `${firstSupplierName} +${extraSuppliersCount} ${extraSuppliersCount === 1 ? 'fornecedor' : 'fornecedores'}`
    }

    return '-'
  }

  onSelectedProtocolDataChange(data: IProtocolo) {
    this.selectedProtocolData = data
  }

  onMaterialDataChange(newMaterialData) {
    const parsedMaterialData: any = {
      descricao: newMaterialData.description,
    }

    parsedMaterialData.opmes = newMaterialData.kitMaterials.map((material => ({
      id: material.id,
      descricao: material.description,
      medicoPodeAlterarAQuantidade: material.canDoctorUpdateQuantity,
      quantidade: material.quantity,
      fornecedor1Id: material.supplierId,
    })))

    this.materialData = parsedMaterialData
  }

  onSelectedKitChange(value) {
    this.doctorSelectedKitId = value
  }

  onSurgeryTechniqueChange(value) {
    this.doctorSurgeryTechnique = value
  }

  onSurgeryProtocolChange(value) {
    this.doctorProtocol = value
  }

  @Watch('doctorReasonProtocolRejection')
  onDoctorReasonChange(value) {
    this.reasonProtocolRejection = value
  }

  @Watch('showModalPendenciaProtocolo')
  async onShowHideModal(show) {
    if (show) {
      const suggestedProtocol = this.availableProtocols.find(protocol => protocol.id === (this.protocolPendencyData && this.protocolPendencyData.protocoloId))

      this.protocol = suggestedProtocol ? suggestedProtocol.id : ''

      const protocolId = this.protocol
      const { hospitalId } = this.surgerySolicitationData

      this.protocolData = await this.backofficeFidelizationStore.getSurgerySolicitationProtocol({ hospitalId, protocolId })
      this.selectedProtocolData = this.protocolData

      const { tecnicasDeCirurgia: protocolSurgeryTechniques } = this.protocolData
      const kitsDeOpme = this.protocolData.kitsDeOpme || []
      const kitsDeOpmeV2 = this.protocolData.kitsDeOpmeV2 || []

      this.availableSurgeryTechniques = protocolSurgeryTechniques && protocolSurgeryTechniques.map(technique => ({
        id: technique.id,
        description: technique.nome,
      }))

      const suggestedSurgeryTechnique = protocolSurgeryTechniques.find(technique => technique.id === (this.protocolPendencyData && this.protocolPendencyData.tecnicaId))

      if (!kitsDeOpmeV2) {
        // Fill using kits de opme v1
        const suggestedKit = kitsDeOpme.find(kit => kit.id === (this.protocolPendencyData && this.protocolPendencyData.kitId))

        this.surgeryTechnique = suggestedSurgeryTechnique ? suggestedSurgeryTechnique.id : ''
        this.selectedKitId = suggestedKit ? suggestedKit.id : ''

        this.doctorProtocol = this.protocol
        this.doctorSelectedKitId = this.selectedKitId
        this.doctorSurgeryTechnique = this.surgeryTechnique

        const surgeryTechniqueKits = kitsDeOpme && kitsDeOpme.length > 0
        && kitsDeOpme.filter(opmeKit => !this.surgeryTechnique || opmeKit.tecnicaDeCirurgia.id === this.surgeryTechnique)

        this.availableSurgeryOpmeKits = surgeryTechniqueKits && surgeryTechniqueKits.length > 0
          && surgeryTechniqueKits.map(opmeKit => ({
            id: opmeKit.id,
            description: opmeKit.nome,
            kitMaterials: opmeKit.opmes.map(opme => ({
              id: opme.id,
              description: opme.descricao,
              quantity: opme.quantidade,
              anvisaCode: opme.codigoAnvisa,
              supplier: this.getOpmeSupplierLabel(this.protocolSuppliers),
              supplierId: '',
              canDoctorUpdateQuantity: opme.medicoPodeAlterarAQuantidade,
            })),
          }))
      } else {
        // Fill using kits de opme v2
        const suggestedKit = kitsDeOpmeV2.find(kit => kit.id === (this.protocolPendencyData && this.protocolPendencyData.kitId))

        this.surgeryTechnique = suggestedSurgeryTechnique ? suggestedSurgeryTechnique.id : ''
        this.selectedKitId = suggestedKit ? suggestedKit.id : ''

        this.doctorProtocol = this.protocol
        this.doctorSelectedKitId = this.selectedKitId
        this.doctorSurgeryTechnique = this.surgeryTechnique

        this.$refs.protocoloComparativo.selectedKit = this.selectedKitId
        this.$refs.protocoloComparativo.updateAvaliableOpmeKits()
      }
    }
  }

  get availableProtocols(): { id: string, description: string }[] {
    return this.solicitacaoCirurgiaStore.protocoloOptions.map(protocol => ({
      id: protocol.id,
      description: protocol.nome,
    }))
  }

  get protocolPendencyData() {
    const surgeryProtocolData = this.surgerySolicitationData && this.surgerySolicitationData.protocoloDeCirurgia
    const surgerySolicitationFidelizationData = surgeryProtocolData && surgeryProtocolData.fidelizacao
    const protocolPendencyData = surgerySolicitationFidelizationData && surgerySolicitationFidelizationData.sugestaoDeProtocolo

    return protocolPendencyData
  }

  get protocolSuppliers() {
    return this.protocolData && this.protocolData.fornecedores.map(elem => ({
      id: elem.fornecedorId,
      description: elem.fornecedorNome,
    }))
  }

  get backofficeFidelizationStore() {
    return getModule(BackofficeFidelizacaoStore, this.$store)
  }

  get solicitacaoCirurgiaStore() {
    return getModule(SolicitacaoCirurgiaStore, this.$store)
  }

  get reservaDeSangueStore() {
    return getModule(ReservaDeSangueStore, this.$store)
  }

  get solicitacaoStore() {
    return getModule(SolicitacaoStore, this.$store)
  }

  get surgerySolicitationData() {
    return this.solicitacaoCirurgiaStore.solicitacaoCirurgia
  }

  get surgerySolicitationProtocolData() {
    const { protocoloDeCirurgia: surgeryProtocol } = this.surgerySolicitationData
    return surgeryProtocol
  }

  get showModalPendenciaProtocolo() {
    return this.solicitacaoStore.modalSolicitacaoCirurgia.showModalPendenciaProtocolo
  }

  async closeProtocolPendencyModal() {
    this.solicitacaoStore.setShowModalPendenciaProtocolo(false)

    // Reset attributes
    this.reasonProtocolRejection = ''
    this.surgeryTechnique = ''
    this.selectedKitId = ''
    this.protocol = ''
    this.availableSurgeryOpmeKits = []
    this.availableSurgeryTechniques = []
    this.backofficeFidelizationStore.setSurgerySolicitationProtocols([])
    this.protocolData = {}
    this.materialData = {
      opmes: [],
    }

    // Reset attributes from protocol comparative
    this.$refs.protocoloComparativo.protocol = ''

    // Clear all storages
    this.solicitacaoCirurgiaStore.clearAll()
    this.solicitacaoCirurgiaStore.clearConsultaPacienteCpf()
    this.solicitacaoCirurgiaStore.clearConsultaPacienteNome()
    this.solicitacaoCirurgiaStore.clearReservaHemocomponentes()
    this.solicitacaoCirurgiaStore.clearSolicitacaoCirurgia()
    this.solicitacaoCirurgiaStore.clearLaudos()
    this.solicitacaoCirurgiaStore.clearLaudosPaciente()
    this.solicitacaoCirurgiaStore.clearLaudosDiversos()
    this.solicitacaoCirurgiaStore.clearLaudosTermoDeConsentimento()
    this.solicitacaoCirurgiaStore.setHospitalNome('')
    this.solicitacaoCirurgiaStore.clearCaixasCirurgicasApi()

    this.solicitacaoStore.clearSolicitacao()
    this.solicitacaoStore.clearTemplateFormulario()

    this.reservaDeSangueStore.clearReservaDeSangue()
  }

  async closeAcceptOrRejectProtocolModal() {
    this.showRejectProtocolModal = false

    this.closeProtocolPendencyModal()
    this.closeManagementSurgeryModal()
  }

  async acceptProtocolSuggestion() {
    try {
      this.loadingSaveProtocol = true

      // Check is material without supplier
      const isThereMaterialWithoutSupplier = this.materialData.opmes.some(opme => !opme.fornecedor1Id || opme.fornecedor1Id === '')

      // Check main procedure from solicitation is different of protocol
      const solicitationMainProcedure = this.solicitacaoCirurgiaStore.solicitacaoCirurgia.procedimento!
      const protocolMainProcedure = this.selectedProtocolData.procedimentoPrincipal
      let isMainProcedureEqual = false

      if (solicitationMainProcedure.codigo === protocolMainProcedure.codigo /* && solicitationMainProcedure.quantidade === protocolMainProcedure.quantidade */) {
        isMainProcedureEqual = true
      }

      // Check associated procedure from solicitation is different of protocol
      // const solicitationAssociatedProcedures = this.solicitacaoCirurgiaStore.solicitacaoCirurgia.procedimentosAssociados || []
      // const protocolAssociatedProcedures = this.selectedProtocolData.procedimentosAssociados || []
      // let isAssociatedProceduresEqual = true

      // if (solicitationAssociatedProcedures.length !== protocolAssociatedProcedures.length) {
      //   isAssociatedProceduresEqual = false
      // } else {
      //   isAssociatedProceduresEqual = !protocolAssociatedProcedures.find((protocolProcedure) => {
      //     // eslint-disable-next-line arrow-body-style
      //     const isProceduresEquals = solicitationAssociatedProcedures.find((solicitationProcedure) => {
      //       return solicitationProcedure.codigo === protocolProcedure.codigo
      //         && solicitationProcedure.quantidade === protocolProcedure.quantidade
      //     })

      //     return !isProceduresEquals
      //   })
      // }

      // Check need select technique
      const kitsDeOpme = this.selectedProtocolData.kitsDeOpmeV2 || this.selectedProtocolData.kitsDeOpme
      const selectedKitDeOpme = kitsDeOpme.find(elem => elem.id === this.selectedKitId)
      const needSelectSurgeryTechnique = selectedKitDeOpme && !!selectedKitDeOpme.tecnicaDeCirurgia

      if (!isMainProcedureEqual /* || !isAssociatedProceduresEqual */) {
        EventBus.$emit('setSnackbar', {
          show: true, text: 'Não será possível utilizar este protocolo pois os procedimentos são diferentes dos procedimentos que estão na solicitação', icon: 'warning', color: '#C62828',
        })
      } else if (!this.doctorProtocol || !this.doctorSelectedKitId || (!this.doctorSurgeryTechnique && needSelectSurgeryTechnique) || isThereMaterialWithoutSupplier) {
        EventBus.$emit('setSnackbar', {
          show: true, text: 'Obrigatório selecionar protocolo, técnica, kit e fornecedores para os materiais', icon: 'warning', color: '#C62828',
        })
      } else {
        this.showConfirmationModal = true
      }
    } catch (error) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Não foi possível realizar a ação', icon: 'warning', color: '#C62828' })
    } finally {
      this.loadingSaveProtocol = false
    }
  }

  async confirmProtocolSuggestion() {
    try {
      this.loadingConfirmProtocolSuggestion = true

      const newSurgeryProtocolData: any = {
        medicoRecusouSeguirOProtocolo: false,
        segueOProtocolo: 'SegueOProtocolo',
        fidelizacao: this.solicitacaoCirurgiaStore.solicitacaoCirurgia.protocoloDeCirurgia
          && this.solicitacaoCirurgiaStore.solicitacaoCirurgia.protocoloDeCirurgia.fidelizacao,
      }

      if (this.doctorProtocol) {
        newSurgeryProtocolData.protocoloDeCirurgiaId = this.doctorProtocol
      }

      if (this.doctorSurgeryTechnique) {
        newSurgeryProtocolData.tecnicaDeCirurgiaId = this.doctorSurgeryTechnique
      }

      if (this.doctorSelectedKitId) {
        newSurgeryProtocolData.kitDeOpmeId = this.doctorSelectedKitId
      }

      this.solicitacaoCirurgiaStore.solicitacaoCirurgia.protocoloDeCirurgia = newSurgeryProtocolData
      this.solicitacaoCirurgiaStore.solicitacaoCirurgia.grupoDeOpme = this.materialData

      // Try update solicitation
      const updateSurgerySolicitationAPIResponse = await this.solicitacaoCirurgiaStore.put({ pendenciaDeProtocolo: true })

      if (updateSurgerySolicitationAPIResponse.success) {
        const solicitacaoId = this.solicitacaoCirurgiaStore.solicitacaoCirurgia.id
        const finalizeSurgerySolicitationAPIResponse = await SolicitacaoCirurgiaApi.finalizar(solicitacaoId, { pendenciaDeProtocolo: true })

        if (finalizeSurgerySolicitationAPIResponse.success) {
          EventBus.$emit('setSnackbar', { show: true, text: 'Cadastro realizado com sucesso!', icon: 'done', color: '#2E7D32' })

          this.showConfirmationModal = false

          this.closeAcceptOrRejectProtocolModal()

          this.doctorProtocol = ''
          this.doctorSurgeryTechnique = ''
          this.doctorSelectedKitId = ''
          this.reasonProtocolRejection = ''
        } else {
          EventBus.$emit('setSnackbar', { show: true, text: 'Não foi possível realizar a ação', icon: 'warning', color: '#C62828' })
        }
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: updateSurgerySolicitationAPIResponse.message || 'Não foi possível realizar a ação', icon: 'warning', color: '#C62828' })
      }
    } catch (error) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Não foi possível realizar a ação', icon: 'warning', color: '#C62828' })
    } finally {
      this.loadingConfirmProtocolSuggestion = false
    }
  }

  async rejectProtocol() {
    try {
      this.loadingSaveProtocol = true

      if (!this.reasonProtocolRejection) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Informe uma justificativa para recusar o protocolo', icon: 'warning', color: '#C62828' })
      } else {
        const newProtocolData = {
          justificativaMedico: this.reasonProtocolRejection,
          justificativaOrigem: ProtocoloJustificativaOrigemEnum.fidelizacao,
        }

        const APIResponse = await this.solicitacaoCirurgiaStore.rejectFidelizationProtocolSuggestion({ id: this.solicitacaoCirurgiaStore.solicitacaoCirurgia.id, payload: newProtocolData })

        if (APIResponse.success) {
          EventBus.$emit('setSnackbar', { show: true, text: 'Protocolo rejeitado com sucesso!', icon: 'done', color: '#2E7D32' })

          this.closeAcceptOrRejectProtocolModal()
        } else {
          EventBus.$emit('setSnackbar', { show: true, text: APIResponse.message || 'Não foi possível realizar a ação', icon: 'done', color: '#2E7D32' })
        }
      }
    } catch (error) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Não foi possível realizar a ação', icon: 'warning', color: '#C62828' })
    } finally {
      this.loadingSaveProtocol = false
    }
  }
}
